/* eslint-disable array-callback-return */
import { type FC } from 'react';
import classNames from 'classnames/bind';
import { type IconPropInterface } from '../../types/types';
import { FAIcon, type IconTheme } from '../../Icons/Icons';
import type { Data, TabProps } from '../types/tabProps';
import styles from './Tab.module.scss';

const cx = classNames.bind(styles);

const Tab: FC<TabProps> = ({ tabList, onClick, activeTab, iconOnly, theme, className, ...restProps }: TabProps) => {
  const tabnames =
    tabList?.map((_element, index) => {
      const tabCClassname = cx(
        'tab-toggle',
        {
          [`${index + 1 === activeTab ? '' : 'in'}active-tab`]: true,
          [`tab-${iconOnly ? 'icon' : 'text'}`]: true,
        },
        [theme],
      );
      return (
        <li
          role="presentation"
          className={tabCClassname}
          key={`Tab${+index}`}
          onClick={() => onClick?.({ index: index + 1, value: _element } as Data)}
          onKeyDown={() => onClick?.({ index: index + 1, value: _element } as Data)}
          data-testid="tab-list-testid"
        >
          {iconOnly ? <FAIcon {...(_element as IconPropInterface)} theme={theme as IconTheme} /> : (_element as string)}
        </li>
      );
    }) || [];
  return (
    <ul
      className={`${styles['tab-container']} ${theme ? styles[theme] : ''} ${className}`}
      {...restProps}
      data-testid="tab-test-id"
    >
      {tabnames}
    </ul>
  );
};

export default Tab;
